import AppConfig from "util/AppConfig";
const useFeaturesCustomization = () => {
  var _a, _b, _c;
  const featureToggles = (_c = (_b = (_a = AppConfig) == null ? void 0 : _a.branding) == null ? void 0 : _b.call(_a)) == null ? void 0 : _c.features;
  return {
    aiInvestigationReport: featureToggles == null ? void 0 : featureToggles.ai_investigation_report,
    widgetSummary: featureToggles == null ? void 0 : featureToggles.widget_summary
  };
};
export default useFeaturesCustomization;
